<template>
    <span>
        <span v-if="name === 'simple-description'">
            <span v-if="hasTypePlusSubtype">{{ typePlusSubtype }},</span>
            <span v-if="hasRooms">{{ rooms }} -</span>
            <span v-if="hasPrice">
                <humanized-money :value="price"></humanized-money>
            </span>
        </span>
        <span v-if="name === 'address'">
            {{ addressLine }}
        </span>
    </span>
</template>

<script>
const { plural } = require('sci/utils')

export default {
    props: {
        name: {
            required: true,
            type: String
        },
        construction: {
            required: true,
            type: Object
        }
    },
    name: 'construction-line',
    computed: {
        addressLine () {
            const { street, street_number, complementary, floor, neighborhood, alternative_neighborhood, city } = this.construction;
            const addressValues = []

            if (street) {
                addressValues.push(street)
            }

            const streetNumberValues = []

            if (street_number) {
                streetNumberValues.push(`nº ${street_number}`)
            }

            if (complementary) {
                streetNumberValues.push(complementary)
            }

            if (streetNumberValues.length) {
                addressValues.push(streetNumberValues.join(' - '))
            }

            if (floor) {
                addressValues.push(`${floor}º andar`)
            }

            const locationValues = []

            if (alternative_neighborhood) {
                locationValues.push(alternative_neighborhood.name)
            } else if (neighborhood) {
                locationValues.push(neighborhood.name)
            }

            if (city) {
                locationValues.push(city.name)
            }

            if (!addressValues.length) {
                if (locationValues.length) {
                    return locationValues.join(' - ')
                }

                return null
            }

            const result = [...addressValues, ...locationValues];

            let line = result.join(', ')

            if (city && city.state) {
                line += ` - ${city.state.abbreviation}`
            }

            return line || null;
        },
        hasTypePlusSubtype () {
            return this.construction.type || this.construction.subtype
        },
        typePlusSubtype () {
            const res = [];

            if (this.construction.type_name) {
                res.push(this.construction.type_name)
            }

            if (this.construction.subtype_name) {
                res.push(this.construction.subtype_name)
            }

            return res.join(' - ')
        },
        hasRooms () {
            return this.construction.count_dorm || this.construction.count_car_garage
        },
        rooms () {
            const res = [];

            if (this.construction.count_dorm) {
                res.push(plural(this.construction.count_dorm, '%s dorm', '%s dorms'))
            }

            if (this.construction.count_car_garage) {
                res.push(plural(this.construction.count_car_garage, '%s vagas', '%s vagas'))
            }

            return res.join(', ')
        },
        hasPrice () {
            return this.construction.for_sale || this.construction.for_rent || this.construction.for_vacation || this.construction.for_lease
        },
        price () {
            let price = 0.0

            if (this.construction.for_sale || this.construction.for_lease) {
                price = this.construction.sell_price || 0.0
            } else {
                price = this.construction.rent_price || 0.0
            }

            return price
        }
    }
}
</script>



// WEBPACK FOOTER //
// Line.vue?0c33db2b